import "./range.css";
import "../../edit.css";
import { useEffect, useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import { CalendarRangeProps } from "./range.props";
import { NewCalendarRangeType } from "../../../operations";
import { useLanguage } from "../../../../hooks";
import { Box } from "../../wrapper";
import { dateFormat } from "../../../../utils";

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

export const CalendarRange: React.FC<CalendarRangeProps> = ({
  show,
  className,
  dateRange,
  setDateRange,
  error: paramError,
  disabled,
}) => {
  const { t } = useLanguage();

  const [newDateRange, setNewDateRange] =
    useState<NewCalendarRangeType>(dateRange);
  const [error, setError] = useState<boolean>(false);
  const [okDisabled, setOkDisabled] = useState<boolean>(false);

  const handleDateChange = (dates: any, dateStrings: any) => {
    if (dates) {
      let start: string = dateStrings[0];
      let end: string = dateStrings[1];
      const today: Date = new Date();
      const endDate = dayjs(end, dateFormat).toDate();
      // dateFormat ("DD/MM/YYYY"), no today.toLocaleDateString() (orden dependiente del locale
      // del navegador — rompía el RangePicker con "Invalid Date" al reabrir el calendario).
      const clampedEnd = endDate > today ? dayjs(today).format(dateFormat) : end;

      setError(false);
      setOkDisabled(false);
      setNewDateRange({
        startDate: start,
        endDate: clampedEnd,
      });
      setDateRange({
        startDate: start,
        endDate: clampedEnd,
      });
    } else {
      setError(true);
      setOkDisabled(true);
      setNewDateRange(undefined);
      setDateRange(dateRange);
    }
  };

  useEffect(() => setNewDateRange(dateRange), [dateRange]);

  return (
    <Box
      show={show}
      error={
        paramError !== undefined && paramError?.length > 0
          ? paramError
          : error
          ? t.components.operations.calendarRange.modal.errorRange
          : ""
      }
      isDisabled={disabled ?? false}
    >
      <RangePicker
        value={[
          dayjs(newDateRange?.startDate ?? dateRange.startDate, dateFormat),
          dayjs(newDateRange?.endDate ?? dateRange.endDate, dateFormat),
        ]}
        format={dateFormat}
        onChange={handleDateChange}
        placeholder={[
          t.components.operations.calendarRange.modal.start,
          t.components.operations.calendarRange.modal.end,
        ]}
        className={`edit-box ${className}`}
        disabled={disabled}
      />
    </Box>
  );
};
